import { ICalendario, IEvento } from "../interfaces";
import api from "../services/api";

interface IEventoPostModel extends Omit<IEvento, "id"> {
    diaDoMes: number;
}

interface IEventoDeleteModel {
    diaDoMes: number;
    eventoId: string;
}

interface IResponseModel {
    evento: IEvento;
    message: string;
}

class CalendarioRepository {
    public async GetSchedule() {
        const response = await api.get<ICalendario[]>("calendario");
        return response.data;
    }

    public async CreateEvent({ diaDoMes, titulo, dataInicio, dataFim }: IEventoPostModel) {
        const response = await api.post<IResponseModel>(`calendario/dia/${diaDoMes}`, {
            titulo: titulo,
            dataInicio: dataInicio,
            dataFim: dataFim
        });
        return response.data;
    }

    public async DeleteEvent({ diaDoMes, eventoId }: IEventoDeleteModel) {
        const response = await api.delete<Pick<IResponseModel, "message">>(`calendario/dia/${diaDoMes}/evento/${eventoId}`);
        return response.data;
    }
}

export default new CalendarioRepository();